export default {"src":"/_next/static/media/icon_23.eb386033.svg","height":48,"width":48};